import React from 'react';
import ComingSoon from './_shared/ComingSoon';

const Community = () => (
  <ComingSoon
    area="Community"
    eyebrow="Community"
    title="Quiet in here. Say something interesting."
    body="A place to talk about being human in general. Strange things people do. Tiny things that made your day better. Weird bits of work. Money nobody explained. Nothing from your Life Profile ever shows up here. Coming soon."
    primaryHref="/my-life"
    primaryLabel="Back to My Life"
    secondaryHref="/"
    secondaryLabel="Home"
    testid="community-page"
  />
);
export default Community;
